import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { loadingTrue, loadingFalse } from "../../../Reducer/loaderSlice";
import Handler from "../../../Helpers/Handler";
import Pagination from "../../../Helpers/Pagination";
import "../../../Assets/css/style.css";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";

const LinkCommunity = () => {
  const { id: event_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [communities, setCommunities] = useState([]);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState(null);
  const [linking, setLinking] = useState(false);
  const limit = 6;

  const fetchCommunities = async () => {
    dispatch(loadingTrue());
    const res = await Handler({
      method: "GET",
      url: `/events/community_search.php?page=${page}&limit=${limit}&q=${query}`,
    });
    dispatch(loadingFalse());
    if (res.success) {
      setCommunities(res.data?.list || []);
      setTotal(res.data?.pagination?.total || 0);
    } else {
      toast.error(res.message || "Failed to load communities");
    }
  };

  useEffect(() => {
    fetchCommunities();
  }, [page, query]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setQuery(search);
  };

  const handleLink = async () => {
    if (!selected) return toast.warning("Please select a community first");
    setLinking(true);
    const res = await Handler({
      method: "POST",
      url: "/events/community_link.php",
      data: {
        event_id: parseInt(event_id),
        community_id: selected.id,
      },
    });
    setLinking(false);
    if (res.success) {
      toast.success("Community linked successfully!");
      navigate(`/user/event/${event_id}`);
    } else {
      toast.error(res.message || "Failed to link community");
    }
  };

  return (
    <MainLayout>
      <FeedLayout>
        <div className="ev-page">
          <button className="ev-btn-back" onClick={() => navigate(`/user/event/${event_id}`)}>
            <i className="bx bx-arrow-back" /> Back to Event
          </button>

          <div className="ev-header mt-2">
            <div>
              <h1 className="ev-title">Link Community</h1>
              <p className="ev-subtitle">Select a community to attach to this event</p>
            </div>
          </div>

          {/* Selected Preview */}
          {selected && (
            <div className="ev-selected-banner">
              <div className="ev-selected-info">
                <i className="bx bx-check-circle ev-selected-icon" />
                <div>
                  <div className="ev-selected-label">Selected Community</div>
                  <div className="ev-selected-name">{selected.name}</div>
                </div>
              </div>
              <button
                className="ev-btn-primary"
                onClick={handleLink}
                disabled={linking}
              >
                {linking ? (
                  <><i className="bx bx-loader-alt bx-spin" /> Linking...</>
                ) : (
                  <><i className="bx bx-link-alt" /> Confirm Link</>
                )}
              </button>
            </div>
          )}

          {/* Search */}
          <form className="ev-search-bar" onSubmit={handleSearch}>
            <i className="bx bx-search ev-search-icon" />
            <input
              className="ev-search-input"
              placeholder="Search communities by name..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button type="submit" className="ev-btn-search">Search</button>
          </form>

          {/* Community Cards */}
          {communities.length === 0 ? (
            <div className="ev-empty">
              <i className="bx bx-group ev-empty-icon" />
              <p>No communities found</p>
            </div>
          ) : (
            <div className="ev-grid">
              {communities.map((c) => (
                <div
                  key={c.id}
                  className={`ev-card ev-community-card ${selected?.id === c.id ? "ev-card-selected" : ""}`}
                  onClick={() => setSelected(selected?.id === c.id ? null : c)}
                >
                  {selected?.id === c.id && (
                    <div className="ev-card-check">
                      <i className="bx bx-check" />
                    </div>
                  )}
                  <div className="ev-community-avatar">
                    {c.name?.charAt(0)?.toUpperCase()}
                  </div>
                  <h3 className="ev-card-title">{c.name}</h3>
                  <p className="ev-card-desc">
                    {c.description
                      ? c.description.substring(0, 80) + (c.description.length > 80 ? "..." : "")
                      : "No description available."}
                  </p>
                  <div className="ev-card-footer">
                    <span className="ev-client">
                      <i className="bx bx-user" /> {c.creator_name || "Unknown"}
                    </span>
                    <span className={`ev-type-tag ${c.type === "PUBLIC" ? "type-public" : "type-private"}`}>
                      {c.type}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {total > limit && (
            <Pagination
              page={page}
              total={total}
              limit={limit}
              onPrev={() => setPage((p) => Math.max(1, p - 1))}
              onNext={() => setPage((p) => p + 1)}
            />
          )}
        </div>
      </FeedLayout>
    </MainLayout>

  );
};

export default LinkCommunity;